import { CommonModule } from '@angular/common';
import { Component, inject, input, signal, } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoggingService } from '@tdoe/design-system';
import { MembershipService } from 'app/services/membership/membership.service';
import { UserService } from 'app/services/user/user.service';
import dayjs from 'dayjs';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { combineLatest, debounceTime, filter, map, mergeMap, tap } from 'rxjs';

@Component({
  selector: 'app-average-daily-membership',
  standalone: true,
  imports: [
    CommonModule,
    NgxSkeletonLoaderModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './average-daily-membership.component.html',
  styleUrl: './average-daily-membership.component.scss'
})
export class AverageDailyMembershipComponent {

  private readonly membershipService = inject(MembershipService);
  private readonly logger = inject(LoggingService);

  public readonly districtIds = input.required<string[]>();
  public readonly schoolIds = input.required<string[]>();
  public readonly year = input.required<number>();

  public isLoading = signal<boolean>(false);

  public viewModel$ =
    combineLatest([
      toObservable(this.districtIds),
      toObservable(this.schoolIds),
      toObservable(this.year)
    ]).pipe(
      map(([districtIds, schoolIds, year]) => ({districtIds, schoolIds, year})),
      debounceTime(300),
      tap(() => this.isLoading.set(true)),
      mergeMap(data => this.membershipService.getMembershipSummary(data.districtIds, data.schoolIds)
      .pipe(
        map(membershipSummaries => ({
          baseAdm: membershipSummaries.map(_ => _.adm ?? 0).reduce((sum, current) => sum + current, 0),
          membership: membershipSummaries.map(_ => _.membership ?? 0).reduce((sum, current) => sum + current, 0),
          currentBaseAdm: membershipSummaries[0]?.adm ?? 0,
          previousBaseAdm: membershipSummaries[1]?.adm ?? 0,
          currentMembership: membershipSummaries[0]?.membership ?? 0,
          previousMembership: membershipSummaries[1]?.membership ?? 0,
          currentYear: membershipSummaries[0]?.year ?? dayjs().year(),
          previousYear: membershipSummaries[1]?.year ?? dayjs().year() - 1
        }))
      )),
      tap(() => this.isLoading.set(false)),
    );

}
